import Base from "../../base";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SideMenu from "../SideMenu";
import LeftMenu from "../../../components/LeftMenu";
import Header from "../Header";
import axiosConfig from "../../../services/Axios";
import { useEffect, useState } from "react";
import RoleLabel from "../../../components/ui/RoleLabel";
import { faEdit, faHandshake } from "@fortawesome/pro-regular-svg-icons";
import Pagination from "../../../components/ui/Pagination";
import SearchForm from "./SearchForm";
import EmptyData from "../../../components/ui/EmptyData";
import Title from "../../../components/ui/Title";
import PopoverMenu from "../../../components/ui/PopoverMenu";

function Partners() {
  const [partners, setPartners] = useState();
  const [formData, setFormData] = useState();
  const { t } = useTranslation();

  useEffect(() => {
    loadPartners(formData);
  }, [formData]);

  const loadPartners = (formData) => {
    let itemsPerPage = 10;
    let url =
      process.env.REACT_APP_API_URL +
      (formData?.page ? formData?.page + "&" : "/api/partners?");

    url = url + "partnerUser.enabled=true";

    if (itemsPerPage) {
      url = url + "&itemsPerPage=" + itemsPerPage;
    }

    if (formData?.name) {
      url = url + "&name=" + formData.name;
    }

    if (formData?.role) {
      url = url + "&partnerUser.roles=" + formData.role;
    }

    axiosConfig.get(url).then((response) => {
      if (response?.status === 200 && response?.data) {
        setPartners(response.data);
      }
    });
  };

  return (
    <Base>
      <Header />
      <div className="py-16 container m-auto px-6 grid grid-cols-12">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2">
          <LeftMenu menu={SideMenu} />
        </div>
        <div className="lg:ml-6 lg:p-8 lg:px-10 text-sm mt-10 lg:mt-0 col-span-12 lg:col-span-9 xl:col-span-10 lg:bg-white rounded-lg">
          <Title icon={faHandshake} title={t("settings.partners.list")} />

          <SearchForm formData={formData} setFormData={setFormData} />
          <div className="bg-bioport-blue-light grid grid-cols-12 text-white font-bold px-4 p-3">
            <div className="col-span-11 lg:col-span-4 text-left">
              {t("partner.raison_soc")}
            </div>
            <div className="hidden lg:block col-span-2 text-center">
              {t("partner.internal_code")}
            </div>
            <div className="hidden lg:block col-span-2 text-center">
              {t("global.form.role")}
            </div>
            <div className="hidden lg:block col-span-3 text-center">
              {t("partnerContact.main")}
            </div>
            <div className="col-span-1 text-center"></div>
          </div>

          {partners &&
            (partners["hydra:totalItems"] === 0 ? (
              <EmptyData className="mt-3">{t("global.no-result")}</EmptyData>
            ) : (
              partners["hydra:member"].map((p, key) => (
                <div
                  className={`grid grid-cols-12 px-4 p-3 hover:bg-gray-50 ${
                    key % 2 === 0 && "bg-gray-100"
                  }`}
                  key={key}
                >
                  <div className="col-span-11 lg:col-span-4 ">
                    <Link
                      to={`/settings/partners/` + p.id}
                      className="hover:underline"
                    >
                      {p.name}
                    </Link>
                    <span className="lg:hidden ml-3">{p.internalCode}</span>
                    <span className="lg:hidden ml-3">
                      <RoleLabel roles={p.partnerUser.roles} />
                    </span>
                  </div>
                  <div className="hidden lg:block col-span-2 text-center">
                    {p.internalCode}
                  </div>
                  <div className="hidden lg:block col-span-2 text-center">
                    <RoleLabel roles={p.partnerUser.roles} />
                  </div>
                  <div className="hidden lg:block col-span-3 text-center ">
                    {
                      Object.values(
                        p.partnerContacts?.filter((c) => c.main === true)
                      )[0]?.firstName
                    }{" "}
                    {
                      Object.values(
                        p.partnerContacts?.filter((c) => c.main === true)
                      )[0]?.lastName
                    }
                  </div>
                  <div className="col-span-1 text-center">
                    <PopoverMenu
                      links={[
                        {
                          link: "/settings/partners/" + p.id,
                          icon: faEdit,
                          label: t("global.edit"),
                          class:
                            "hover:cursor-pointer hover:underline text-bioport-blue",
                        },
                      ]}
                    />
                  </div>
                </div>
              ))
            ))}
          {partners &&
            partners["hydra:member"] &&
            partners["hydra:totalItems"] > partners["hydra:member"].length &&
            partners["hydra:view"] && (
              <Pagination
                data={partners}
                onClick={(page) => {
                  setFormData((formData) => ({
                    ...formData,
                    page: page,
                  }));
                }}
              />
            )}
        </div>
      </div>
    </Base>
  );
}

export default Partners;
